import { STATUS } from "@/constants/statuses";
import { applyTransaction } from "@datorama/akita";
import { catchError, tap } from "rxjs";
import { inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { CreateDraftOrderRequestBody } from "./../api_services/GiftRegistryApiService";
import { GiftRegistryApiService } from "../api_services/GiftRegistryApiService";
import { GiftRegistryItemEntity } from "../entities/GiftRegistryItemEntity";
import GiftCartStore from "../stores/GiftCartStore";
import { giftRegistryApplicationLoggerToken } from "../tokens";

@singleton()
class GiftCartService {
    constructor(
        private readonly giftCartStore: GiftCartStore,
        private readonly giftRegistryApiService: GiftRegistryApiService,
        @inject(giftRegistryApplicationLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    addItem(addedItem: GiftRegistryItemEntity, quantity: number) {
        this.giftCartStore.update((state) => ({
            ...state,
            items: state.items.some((item) => item.id === addedItem.id)
                ? state.items.map((item) =>
                      item.id === addedItem.id ? { ...item, quantity } : item
                  )
                : [...state.items, { ...addedItem, quantity }],
        }));
    }

    deleteItem(id: number) {
        this.giftCartStore.update((state) => ({
            ...state,
            items: state.items.filter((item) => item.id !== id),
        }));
    }

    createDraftOrder(data: CreateDraftOrderRequestBody) {
        this.logger.debug("GiftCartService.createDraftOrder is started");
        this.giftCartStore.setStatus(STATUS.LOADING);

        return this.giftRegistryApiService.createDraftOrder(data).pipe(
            catchError((error: unknown) => {
                applyTransaction(() => {
                    this.giftCartStore.setError(error);
                    this.giftCartStore.setStatus(STATUS.ERROR);
                });
                this.logger.debug(
                    "GiftCartService.createDraftOrder is errored",
                    { error }
                );
                throw error;
            }),
            tap((response) => {
                this.logger.debug(
                    "GiftCartService.createDraftOrder is ready",
                    response
                );
                this.giftCartStore.setStatus(STATUS.READY);
            })
        );
    }
}

export default GiftCartService;
